import controller from './date-group.controller'
import template from './date-group.html'

const DateGroupComponent = {
	bindings: {
		selectedDate: '<',
		language: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default DateGroupComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/date-group/date-group.component.js